module.exports = __webpack_public_path__ + "img/img-main-02.342cdcf2.svg";